import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import { LedgerCloseSettings, LedgerCloseSettingsUpdate } from '../interfaces/accounting.interface';

export const LedgerCloseSettingsService = {
    get: async (): Promise<LedgerCloseSettings> => {
        const institutionId = AuthService.getSelectedInstitution();
        const res = await axios.get(ENDPOINTS.LEDGER_CLOSE_SETTINGS.BY_INSTITUTION(institutionId!));
        return res.data;
    },
    update: async (dto: LedgerCloseSettingsUpdate): Promise<LedgerCloseSettings> => {
        const institutionId = AuthService.getSelectedInstitution();
        const res = await axios.put(ENDPOINTS.LEDGER_CLOSE_SETTINGS.UPDATE(institutionId!), dto);
        return res.data;
    },
};
